import store from "@/store";
import { Roles } from "@/types";
import { parseJsonField } from "@/utils/emailForm";

export const getClientNameFromOffer = (offer: any, taskVars: any): string => {
  const customerParty = offer?.associatedParties?.find(
    (party: any) => party.associatedParty?.role?.resourceUid === Roles.CUSTOMER
  );
  let clientName = taskVars?.customerName || "-";
  if (customerParty) {
    const third = customerParty.associatedParty?.third;
    if (third?.type?.id?.includes("Organization")) {
      clientName = third?.organization?.name || third?.name || clientName;
    } else if (third?.person) {
      const person = third.person;
      clientName =
        [person.firstName, person.lastName || person.familyName].filter(Boolean).join(" ").trim() ||
        clientName;
    }
  }
  return clientName;
};

export const getEmailHeaderInfo = (offerReference?: string) => {
  const offer =
    store.state.taskModule.offer ?? store.state.demandModule.offer ?? null;
  const taskVars = store.state.taskModule.selectedTask?.variables;

  const distributorParty = offer?.associatedParties?.find(
    (party: any) => party.associatedParty?.role_code === Roles.DISTRIBUTOR
  );
  const distributorThird = distributorParty?.associatedParty?.third;
  const agencyName =
    distributorThird?.organization?.commercialName ||
    (distributorThird as { commercialName?: string } | undefined)?.commercialName ||
    "-";

  const salesPerson = store.state.demandModule.assignedSalesPerson;
  const commercialName = salesPerson || "-";

  const lizfiNumber =
    offerReference || offer?.reference || taskVars?.offerReference || "-";
  const businessData = parseJsonField(offer?.businessData);
  const offerNumber = businessData?.proposalReference || "-";
  const externalReference =
    offer?.externalReference ||
    businessData?.externalReference ||
    taskVars?.externalReference ||
    "";
  const dossierNumber = `${lizfiNumber} / ${offerNumber}`;
  const clientName = getClientNameFromOffer(offer, taskVars);

  return {
    agencyName,
    commercialName,
    dossierNumber,
    lizfiNumber,
    offerNumber,
    externalReference,
    clientName,
  };
};

export const buildPrintDocumentDefaultBody = (offerReference?: string) => {
  const { agencyName, commercialName, dossierNumber, clientName, lizfiNumber } =
    getEmailHeaderInfo(offerReference);

  return `AGENCE : ${agencyName}

COMMERCIAL : ${commercialName}

N° DOSSIER : ${dossierNumber}

CLIENT : ${clientName}

Bonjour,

Veuillez trouver ci-joint les documents relatifs à l'offre référence ${lizfiNumber}.

Cordialement`;
};
